export enum AuthenticationModalKind {
	SignIn = "SignIn",
	ForgotPassword = "ForgotPassword",
	PasswordReset = "PasswordReset",
	Register = "Register",
	RegisterSuccess = "RegisterSuccess",
	ConfirmSignUp = "ConfirmSignUp",
	ResendConfirmationCode = "ResendConfirmationCode",
}
